
module.exports = {
    colors: {
        hpPrimary: '#024AD8',
        hpPrimaryHover: '#103FB2',
        hpPrimaryPressed: '#0E3191',
        hpPrimaryTint0: '#E4EEFA',
        hpPrimaryTint1: '#C9E0FC',
        hpPrimaryTint2: '#B2D2FF',

        hpOrangeBloom: '#FF5050',
        hpPowerStorm: '#568393',

        hpWhite: '#FFFFFF',
        hpBlack: '#000000',

        hpLightGray: '#F5F5F5',
        hpSoftGray: '#F5F5F5',
        hpMediumGray: '#E8E8E8',
        hpLessHigherGray: '#A3A3A3',
        hpHighGray: '#A3A3A3',
        hpGray: '#636363',
        hpDeepGray: '#636363',
        hpLittleDeepGray: '#636363',
        hpDeeperGray: '#525252',
        hpDeepestGray: '#525252',
        hpFooterBackground: '#525252',

        hpLighterBlack: '#000000',
        hpLightBlack: '#000000',
        hpMediumBlack: '#000000',
        hpDeepBlack: '#000000',
        hpDeepestBlack: '#000000',
        hpLightestBlack: 'rgba(0, 0, 0, 0.25)',

        hpLightestBlue: 'rgb(0, 191, 243)',
        hpLightYellow: 'rgb(255, 255, 51)',
        hpLightOrange: 'rgb(255, 133, 3)',
        hpMediumOrange: 'rgb(224, 121, 0)',
        hpRed: 'rgb(255, 0, 0)',
        hpLightRed: 'rgb(215, 65, 11)',
        hpDeepRed: 'rgb(210, 58, 52)',
        hpDeepGreen: 'rgb(0, 166, 82)',

        hpPageBackground: '#FFFFFF',
        hpOverlay: 'rgba(0, 0, 0, 0.4)',
        hpOnPrimaryDisabled: 'rgba(255, 255, 255, 0.25)',
    },

    fonts: {
        family: '"Forma DJR UI", Arial, Helvetica, sans-serif',
        weightRegular: 400,
        weightMedium: 500,
        pdfFamily: 'FormaDJRUI',
    },
};
